import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22KiLabel.tsx%22,%22import%22:%22Roboto_Mono%22,%22arguments%22:[{%22subsets%22:[%22latin%22]}],%22variableName%22:%22robotoMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Roboto Mono', 'Roboto Mono Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
